import { UserEventMessage } from '@/lib/models/user-event';

export type ConversationInfiniteScrollProps = {
  hasMoreMessages?: boolean;
  isFetchingMoreMessages?: boolean;
  onLoadMoreMessages?: () => void;
  hasOlderMessages?: boolean;
  isFetchingOlderMessages?: boolean;
  onLoadOlderMessages?: () => void;
};

export type MessageGroup = {
  key: string;
  messages: UserEventMessage[];
  isFocused: boolean;
};

export const getMessageGroupKey = ({ requestId, timestamp }: UserEventMessage): string =>
  `${requestId}-${timestamp}`;
